module.exports = __webpack_public_path__ + "static/media/cases_logos_esportivos_01.9f731294.jpg";